import { createFileRoute, Outlet, useParams } from '@tanstack/react-router'
import { StartupRouteGuard } from '../../../contexts/startup-guard'

export const Route = createFileRoute('/app/startup/$id')({
  component: StartupRoute,
})

function StartupRoute() {
  const { id } = useParams({ from: '/app/startup/$id' })
  return (
    <StartupRouteGuard startupId={id}>
      <Outlet />
    </StartupRouteGuard>
  )
}
